<ventabula-chart #chart [showElevation]="showElevation"></ventabula-chart>